import { createRouter, createWebHashHistory } from 'vue-router'
import { routes } from './routes'
import { installRouterGuards } from './guards'

const router = createRouter({
  history: createWebHashHistory(import.meta.env.BASE_URL),
  routes,
  scrollBehavior: () => ({ top: 0 }),
})

installRouterGuards(router)
export default router
